import React from 'react';
import styles from './SingleHorizontalBarChart.module.scss';

interface SingleHorizontalBarChartProps {
  total: number;
  metric: number;
}

const SingleHorizontalBarChart: React.FC<SingleHorizontalBarChartProps> = ({
  total,
  metric,
}) => {
  const isValidNumber = (value: number): boolean =>
    !Number.isNaN(value) && Number.isFinite(value);

  const completionPercentage =
    isValidNumber(total) && isValidNumber(metric)
      ? (Number(metric) / Number(total)) * 100
      : 0;

  return (
    <div className={styles.chartContainer}>
      <div className={styles.chartBackground}>
        <div
          className={styles.chartFill}
          style={{
            width: Number(completionPercentage)
              ? `${completionPercentage}%`
              : `0%`,
          }}
        />
      </div>
    </div>
  );
};

export default SingleHorizontalBarChart;
